import { Family, Member } from "../patents/patents";

const lookbackYears = 10

// start: start date (yyyy-mm-dd);
// end: end date (yyyy-mm-dd);
// today: today's date (yyyy-mm-dd);
export function aggregateOverYears(members: { start: string, end?: string }[], today: string) {
    const currentYear = parseInt(today.slice(0, 4), 10);

    // Prepare counters
    const activeDelta: Record<number, number> = {};
    const started: Record<number, number> = {};
    const stopped: Record<number, number> = {};

    let minYear = currentYear;

    // Parse ranges into events
    for (const { start: startDate, end: endDate } of members) {
        const start = parseInt(startDate.slice(0, 4), 10);
        const end = endDate ? parseInt(endDate.slice(0, 4), 10) : (currentYear + 1); // just assume non-expired/non-abandondened patents expire next year

        if (start < minYear) {
            minYear = start;
        }

        // ignore same year changes
        if (start !== end) {
            // Mark the beginning of activity
            activeDelta[start + 1] = (activeDelta[start + 1] || 0) + 1;
            // Mark the end of activity
            activeDelta[end] = (activeDelta[end] || 0) - 1;
        }

        // Count starts and stops for exact years
        started[start] = (started[start] || 0) + 1;
        stopped[end] = (stopped[end] || 0) + 1;
    }

    // Calculate active counts year by year
    const result: { year: number; active: number; started: number; stopped: number }[] = [];
    let activeCount = 0;

    for (let year = minYear; year <= currentYear; year++) {
        // Update the active count for the current year
        activeCount += activeDelta[year] || 0;

        // Collect the data for the year
        result.push({
            year,
            active: activeCount,
            started: started[year] || 0,
            stopped: stopped[year] || 0,
        });
    }

    return result.slice(-lookbackYears - 1);
}


export function prepareMembers(members: Member[], familyById: Record<number, Family>, {today}: {today?: string} = {}) {
    const _today = today ?? new Date().toISOString().split('T')[0];
    function onlyFromThePast(date?: string) {
        return (date && date < _today) ? date : undefined
    }
    return members
      .filter(m => m.familyMemberStatus !== 'in-preparation')
      .map(member => {
        const family = familyById[member.patentFamilyId]
        const start = member.applicationDate ?? family.priorityDate
        // expiry date must be in the past
        const end = member.abandonmentDate ?? onlyFromThePast(member.expiryDate)
        return {
          start,
          end,
          reference: member.internalReference,
          familyMemberStatus: member.familyMemberStatus,
        }
      })
}